import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Acquisition tab body (SWOOP-159), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview/acquisition`. Permission gating (`vehicles:list`) is inherited from the
 * layout route's `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/acquisition')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-acquisition-page')),
  staticData: { titleKey: 'vehicleAcquisition' },
});
